<template>
    <CCard class="scroll-bar">
        <div class="input-group mb-3">
            <input
                type="text"
                class="form-control border-0 bg-light"
                :placeholder="$t('product.search_site')"
                v-model="searchStore"
            />
        </div>
        <template v-if="searchStore.length === 0">
            <p v-for="(item, index) in selectableStores" :key="index" class="mb-2 mr-1">
                <span
                    @click="filters.store_id = item.id, emitStore(), filtersSet.store_id.value = item.name"
                    style="cursor: pointer;"
                >{{ item.name }}</span>
            </p>
        </template>
        <template v-else-if="!notFoundStore">
            <p v-for="(item, index) in foundedStore" :key="index" class="mb-2 mr-1">
                <span
                    @click="filters.store_id = item.id, emitStore(), filtersSet.store_id.value = item.name, searchStore = ''"
                    style="cursor: pointer;"
                >{{ item.name }}</span>
            </p>
        </template>
        <p v-else-if="notFoundStore" class="text-danger">{{ $t('product.not_found') }}</p>
    </CCard>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'StoreSearch',

    props: {
        selectableStores: {
            default: []
        }
    },

    data() {
        return {
            searchStore: '',
            foundedStore: [],
            notFoundStore: false,
        }
    },

    computed: {
        ...mapGetters({
            filtersSet: 'product/filtersSet',
            filters: 'product/filters',
        }),
    },

    methods: {
        emitStore() {
            this.$emit('emitStore')
        },
    },

    watch: {
        searchStore(text) {
            if (text) {
                this.foundedStore = []
                this.notFoundStore = false
                this.selectableStores.forEach(element => {
                    element.name.startsWith(text) ? this.foundedStore.push({ name: element.name, id: element.id }) : null
                })
                if (this.foundedStore.length === 0) {
                    this.notFoundStore = true
                }
            }
        },
    },
}
</script>

<style scoped>
.scroll-bar {
    width: 220px;
    height: 200px;
    overflow-y: scroll;
    padding: 10px;
    margin-bottom: 5px;
}
.scroll-bar::-webkit-scrollbar {
    display: none;
}
</style>